
/*
 * Custom Cart Discount
 * Shopify + Prestige
 *
 * - No page reload
 * - No drawer replacement
 * - Preserves drawer scroll position
 * - Uses Shopify Section Rendering
 */

(() => {
  "use strict";

  if (window.__customCartDiscountLoaded) return;
  window.__customCartDiscountLoaded = true;

  const root = window.Shopify?.routes?.root || "/";
  const updateUrl = root + "cart/update.js";

  let busy = false;

  
function getWidget(element) {
  const directWidget = element.closest(
    "[data-cart-discount]"
  );

  if (directWidget) return directWidget;

  const footer = element.closest(
    ".cart-drawer__footer"
  );

  return footer?.querySelector(
    "[data-cart-discount]"
  ) || null;
}


  
let messageTimer;
let messageHideTimer;

function setMessage(widget, message, type = "") {
  const target = widget.querySelector(
    "[data-discount-message]"
  );

  if (!target) return;

  clearTimeout(messageTimer);
  clearTimeout(messageHideTimer);

  target.classList.remove("is-hiding");

  target.textContent = message;
  target.dataset.type = type;

  if (!message) return;

  // Nachricht 3 Sekunden sichtbar lassen
  messageTimer = setTimeout(() => {
    target.classList.add("is-hiding");

    // Nach der Fade-out-Animation entfernen
    messageHideTimer = setTimeout(() => {
      target.textContent = "";
      target.classList.remove("is-hiding");
    }, 300);

  }, 3000);
}


  
function setLoading(widget, loading) {
  const input = widget.querySelector(
    "[data-discount-input]"
  );

  const apply = widget.querySelector(
    "[data-discount-apply]"
  );

  const removeButtons = widget.closest(
    ".cart-drawer__footer"
  )?.querySelectorAll("[data-discount-remove]") || [];

  widget.classList.toggle("is-loading", loading);

  if (input) {
    input.disabled = loading;
  }

  // Anwenden-Button: Text bleibt im DOM,
  // Spinner wird per CSS darübergelegt.
  if (apply) {
    apply.disabled = loading;
    apply.classList.toggle("is-loading", loading);
    apply.setAttribute("aria-busy", String(loading));
  }

  // Entfernen-Buttons: X wird zum Spinner.
  removeButtons.forEach((button) => {
    button.disabled = loading;
    button.classList.toggle("is-loading", loading);
    button.setAttribute("aria-busy", String(loading));
  });
}


  function getAppliedCodes(widget) {
    return Array.from(
      widget.querySelectorAll(
        "[data-applied-discount-code]"
      )
    ).map((element) =>
      element.dataset.appliedDiscountCode.trim()
    );
  }

  function normalizeCode(code) {
    return code.trim().toLocaleLowerCase();
  }

  async function updateShopifyDiscount(
    codes,
    sectionId
  ) {
    const response = await fetch(updateUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        discount: codes.join(","),
        sections: [sectionId],
        sections_url:
          window.location.pathname +
          window.location.search
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        "Shopify request failed"
      );
    }

    return data;
  }

  function updateVisibleCart(widget, data) {
    const sectionId = widget.dataset.sectionId;
    const sectionHtml = data.sections?.[sectionId];

    if (!sectionHtml) {
      throw new Error(
        "Updated cart section was not returned"
      );
    }

    const documentFragment = new DOMParser()
      .parseFromString(sectionHtml, "text/html");

    const newDrawer = documentFragment.querySelector(
      "#cart-drawer"
    );

    if (!newDrawer) {
      throw new Error(
        "Updated cart drawer markup not found"
      );
    }

    const currentDrawer = document.querySelector(
      "#cart-drawer"
    );

    if (!currentDrawer) {
      throw new Error("Current drawer not found");
    }

    /*
     * Only update discount-dependent elements.
     * Do not replace the drawer, footer or form.
     */

    
/*
 * Synchronize line items after discount changes.
 * Shopify may change line-item keys when discounts
 * are applied or removed.
 *
 * Keep the existing drawer instance and preserve
 * the scroll position.
 */

const currentItems = currentDrawer.querySelector(
  ".cart-drawer__items"
);

const newItems = newDrawer.querySelector(
  ".cart-drawer__items"
);

if (currentItems && newItems) {
  // Scrollposition des Drawers sichern
  const drawerScrollTop = currentDrawer.scrollTop;
  const itemsScrollTop = currentItems.scrollTop;

  // Nur die Produktzeilen aktualisieren
  currentItems.innerHTML = newItems.innerHTML;

  // Scrollposition wiederherstellen
  currentDrawer.scrollTop = drawerScrollTop;
  currentItems.scrollTop = itemsScrollTop;
}


    const currentActive = widget.querySelector(
      "[data-discount-active]"
    );

    const newActive = newDrawer.querySelector(
      "[data-discount-active]"
    );

    if (currentActive && newActive) {
      currentActive.innerHTML = newActive.innerHTML;
    }

    const currentRows = currentDrawer.querySelector(
      "[data-cart-discount-rows]"
    );

    const newRows = newDrawer.querySelector(
      "[data-cart-discount-rows]"
    );

    if (currentRows && newRows) {
      currentRows.innerHTML = newRows.innerHTML;
    }

    const currentPrice = currentDrawer.querySelector(
      ".cart-drawer__button-price"
    );

    const newPrice = newDrawer.querySelector(
      ".cart-drawer__button-price"
    );

    if (currentPrice && newPrice) {
      currentPrice.textContent = newPrice.textContent;
    }

    return getAppliedCodes(widget);
  }

  async function performUpdate(widget, codes, action, code) {
    if (busy) return;

    busy = true;
    setLoading(widget, true);
    setMessage(widget, "");

    let requestSucceeded = false;

    try {
      const sectionId = widget.dataset.sectionId;

      const data = await updateShopifyDiscount(
        codes,
        sectionId
      );

      requestSucceeded = true;

      const appliedCodes = updateVisibleCart(
        widget,
        data
      );

      const input = widget.querySelector(
        "[data-discount-input]"
      );

      
if (action === "remove") {
  if (input) input.value = "";

  // Keine Nachricht beim erfolgreichen Entfernen
  setMessage(widget, "");

  return;
}


      const isApplied = appliedCodes.some(
        (appliedCode) =>
          normalizeCode(appliedCode) ===
          normalizeCode(code)
      );

      

if (isApplied) {
  if (input) input.value = "";

  // Keine Erfolgsmeldung anzeigen
  setMessage(widget, "");

} else {
  setMessage(
    widget,
    widget.dataset.discountInvalid ||
      "Dieser Rabattcode ist ungültig.",
    "error"
  );
}



    } catch (error) {
      console.error(
        "[Custom Cart Discount]",
        error
      );

      
setMessage(
  widget,
  requestSucceeded
    ? (
        widget.dataset.discountSyncError ||
        "Der Rabatt wurde an Shopify übermittelt, aber die Anzeige konnte nicht vollständig aktualisiert werden. Bitte prüfe den Rabatt im Checkout."
      )
    : (
        widget.dataset.discountRequestError ||
        "Der Rabattcode konnte nicht verarbeitet werden. Bitte versuche es erneut."
      ),
  requestSucceeded ? "info" : "error"
);

    } finally {
      busy = false;

      if (widget.isConnected) {
        setLoading(widget, false);
      }
    }
  }

  async function applyDiscount(widget) {
    const input = widget.querySelector(
      "[data-discount-input]"
    );

    const code = input?.value.trim();

    
if (!code) {
  return;
}


    /*
     * Preserve existing applied codes.
     * Shopify expects a comma-separated list.
     */

    const existingCodes = getAppliedCodes(widget);

    const codes = [
      ...existingCodes.filter(
        (existing) =>
          normalizeCode(existing) !==
          normalizeCode(code)
      ),
      code
    ];

    await performUpdate(
      widget,
      codes,
      "apply",
      code
    );
  }

  async function removeDiscount(widget) {
    /*
     * Removes all manually applied discount codes.
     * Automatic discount rules are managed by Shopify.
     */

    await performUpdate(
      widget,
      [],
      "remove",
      ""
    );
  }

  /*
   * Event delegation:
   * Works even if Prestige re-renders elements.
   */

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;

    const apply = event.target.closest(
      "[data-discount-apply]"
    );

    const remove = event.target.closest(
      "[data-discount-remove]"
    );

    if (!apply && !remove) return;

    const widget = getWidget(apply || remove);
    if (!widget) return;

    event.preventDefault();

    if (apply) {
      applyDiscount(widget);
    } else {
      removeDiscount(widget);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Enter") return;
    if (!(event.target instanceof Element)) return;

    const input = event.target.closest(
      "[data-discount-input]"
    );

    if (!input) return;

    event.preventDefault();

    const widget = getWidget(input);

    if (widget) {
      applyDiscount(widget);
    }
  });
})();
